import React from "react";
import AboutUs from "../components/landingPageComponents/About";
import SEO from "../components/SEO";

function AboutPage() {
  return (
    <>
      <SEO
        title="About - Aastha Computers"
        description="Learn about Aastha Computes, Bikaner's premier computer coaching institute offering expert training in various computer courses for all age groups. Discover our mission, vision, and dedicated teaching staff."
        pagePath="/about"
      />
      <AboutUs />
    </>
  );
}

export default AboutPage;
